import AncillaryUIModel from './ancillary';

class UpgradeAncillaryOfferUIModel {
  constructor({
    appliesToIndividualLegs,
    appliesToIndividualPassengers,
    ancillary,
    discountPrice,
    segmentCode,
    _meta,
  }) {
    this.discountPrice = discountPrice;
    this.appliesToIndividualLegs = appliesToIndividualLegs;
    this.appliesToIndividualPassengers = appliesToIndividualPassengers;
    this.ancillary = new AncillaryUIModel(ancillary);
    this.segmentCode = segmentCode;
    this.offerClass = _meta.class; // 'UpgradeOffer';
    this._meta = _meta; // { class: 'UpgradeOffer' };
  }
}

export default UpgradeAncillaryOfferUIModel;
